module.exports = __webpack_public_path__ + "img/history-version.bccc2bdd.png";